import { useQuery } from '@tanstack/react-query'
import { axiosInstance } from '../../helpers'
import { LeaseAuditEvent } from '../../models'

export const useAuditEvents = (organizationId: number) => {
    const eventListQueryKey = ['audit-events', organizationId] as const

    const {
        data: events,
        isLoading: isLoadingEvents,
        error: errorEvents,
    } = useQuery<LeaseAuditEvent[]>({
        queryKey: eventListQueryKey,
        queryFn: async () => {
            const res = await axiosInstance.get<LeaseAuditEvent[]>(
                '/document-audit/schedule-event/',
                {
                    params: {
                        organization_id: organizationId,
                    },
                },
            )
            return res.data
        },
    })

    return {
        events,
        isLoadingEvents,
        errorEvents,
        eventListQueryKey,
    }
}
